import { mobileSliderInit } from '../functions'
import { Autoplay } from "swiper/modules";

mobileSliderInit(".features__slider", {
    media: 768,
    sliderOptions: {
        modules: [Autoplay],
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        autoplay: true,
        breakpoints: {
            500: {
                slidesPerView: 1.5,
            },
        },
    },
});
